import type { DashboardWidget } from '@/stores/dashboard/types'
import { normalizeWidgetKey } from '@/views/Dashboard/dashboardUtils'

export const DASHBOARD_MACHINE_REVIEW_CODE_NAME = 'machineReview'

export const DASHBOARD_SHIPPERS = [
    { code: 'DPD', name: 'DPD' },
    { code: 'GLS', name: 'GLS' },
    { code: 'INPOST', name: 'InPost' }
] as const

const LARGE_WIDGET_NORMALIZED_KEYS = [
    'fourmonthscomplaintsreport',
    'numberofordersperimposition',
    'paperneededreport',
    'threemonthsreport',
    'threemonthstotalreport',
    'usertasksnotfinished'
] as const

const dashboardLargeWidgetKeySet = new Set<string>(LARGE_WIDGET_NORMALIZED_KEYS)

export function isDashboardWidgetLarge(widget: DashboardWidget | null | undefined): boolean {
    const keys = [normalizeWidgetKey(widget?.codeName), normalizeWidgetKey(widget?.type)]
    return keys.some((k) => k && dashboardLargeWidgetKeySet.has(k))
}

export function getDashboardItemInitialQuery(codeName: string | undefined): string {
    if (codeName === 'ordersSentDailyByShipper') {
        return `sent_date=${new Date().toISOString().slice(0, 10)}`
    }
    if (codeName === 'ordersProcesses' || codeName === 'processedOrders' || codeName === 'newOrders') {
        return 'dataFromStatusLogService=true'
    }
    return ''
}
